<template>
  <div class="modal-container clearfix">
    <vxe-form
        ref="xForm"
        class="my-form2"
        title-align="right"
        title-width="140"
        :data="formData"
        :rules="formRules"
        @reset="reset"
        v-if="isShowDetail"
    >
      <vxe-form-item span="24">
        <template>
          <div class="block-car">
            <div class="block-tip"></div>
            <span class="block-title">行驶证照片</span>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item
          title="行驶证(正面)"
          field="drivingCardFrontImage"
          span="8"
          style="height: 100px"
      >
        <template>
          <div style="display: flex">
            <div
                v-if="!readOnly"
                style="display: flex; flex-direction: column; align-items: center"
            >
              <img style="margin-right: 5px" src="@/assets/images/common/xszzm.png"/>
              <span style="font-size: 8px; color: #539fff">示例图</span>
            </div>
            <upload-img
                :row="formData"
                :readOnly="readOnly"
                :fileKey="'drivingCardFrontImage'"
                :initFile="formData.drivingCardFrontImage"
                :width="80"
                :height="80"
                :isOcrVehicle="true"
                @getOcrVehicle="getOcrVehicle"
                :isFront="true"
            ></upload-img>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item
          title="行驶证(副页)"
          field="drivingCardSubpageImage"
          span="8"
          style="height: 100px"
      >
        <template>
          <div style="display: flex">
            <div
                v-if="!readOnly"
                style="display: flex; flex-direction: column; align-items: center"
            >
              <img style="margin-right: 5px" src="@/assets/images/common/xszfm.png"/>
              <span style="font-size: 8px; color: #539fff">示例图</span>
            </div>
            <upload-img
                :row="formData"
                :readOnly="readOnly"
                :fileKey="'drivingCardSubpageImage'"
                :initFile="formData.drivingCardSubpageImage"
                :width="80"
                :height="80"
                :isOcrVehicle="true"
                @getOcrVehicle="getOcrVehicle"
            ></upload-img>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item span="24">
        <template>
          <div class="block-car">
            <div class="block-tip"></div>
            <span class="block-title">基本信息</span>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="车牌号" field="carNum" span="8">
        <template v-slot:header><span style="color: red">*</span>车牌号</template>
        <template v-slot="scope">
          <vxe-input
              :class="carNumCheck ? 'rowInput check' : 'rowInput'"
              v-model="formData.carNum"
              :readonly="readOnly"
              :placeholder="readOnly ? '' : '请输入车牌号'"
              :clearable="!readOnly"
              @input="$refs.xForm.updateStatus(scope)"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="车辆类型" field="carTypeText" span="8">
        <template>
          <Cascader
              v-model="formData.carTypeText"
              :disabled="readOnly"
              :data="carTypeList"
              trigger="hover"
          ></Cascader>
        </template>
      </vxe-form-item>
      <vxe-form-item title="车牌颜色" field="carNumColor" span="8">
        <template>
          <Select v-model="formData.carNumColor" :disabled="readOnly">
            <Option v-for="(item, index) in car_Num_Color" :value="item.value" :key="index">{{
                item.label
              }}
            </Option>
          </Select>
        </template>
      </vxe-form-item>
      <vxe-form-item title="车长(mm)" field="carLength" span="8">
        <template v-slot="scope">
          <vxe-input
              class="rowInput"
              v-model="formData.carLength"
              :readonly="readOnly"
              :placeholder="readOnly ? '' : '请与行驶证保持一致'"
              :clearable="!readOnly"
              type="number"
              @input="$refs.xForm.updateStatus(scope)"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="车宽(mm)" field="carWidth" span="8">
        <template v-slot="scope">
          <vxe-input
              class="rowInput"
              v-model="formData.carWidth"
              :readonly="readOnly"
              :placeholder="readOnly ? '' : '请与行驶证保持一致'"
              :clearable="!readOnly"
              type="number"
              @input="$refs.xForm.updateStatus(scope)"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="车高(mm)" field="carHeight" span="8">
        <template v-slot="scope">
          <vxe-input
              class="rowInput"
              v-model="formData.carHeight"
              :readonly="readOnly"
              :placeholder="readOnly ? '' : '请与行驶证保持一致'"
              :clearable="!readOnly"
              type="number"
              @input="$refs.xForm.updateStatus(scope)"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="车辆能源类型" field="energyType" span="8">
        <template>
          <Select v-model="formData.energyType" :disabled="readOnly">
            <Option v-for="(item, index) in energy_Type" :value="item.value" :key="index">{{
                item.label
              }}
            </Option>
          </Select>
        </template>
      </vxe-form-item>
      <vxe-form-item span="24">
        <template>
          <div class="block-car">
            <div class="block-tip"></div>
            <span class="block-title">行驶证信息</span>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="车辆行驶证档案编号" field="archivesNum" span="8">
        <template v-slot="scope">
          <vxe-input
              :class="archivesNumCheck ? 'rowInput check' : 'rowInput'"
              v-model="formData.archivesNum"
              :readonly="readOnly"
              :placeholder="readOnly ? '' : '请输入车辆行驶证档案编号'"
              :clearable="!readOnly"
              @blur="clearV"
              @input="updateScope(scope,'archivesNumCheck')"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="车辆识别代码" field="identCode" span="8">
        <template v-slot="scope">
          <vxe-input
              :class="identCodeCheck ? 'rowInput check' : 'rowInput'"
              v-model="formData.identCode"
              :readonly="readOnly"
              :placeholder="readOnly ? '' : '请输入17位车辆识别代码'"
              :clearable="!readOnly"
              @blur="clearV"
              @input="updateScope(scope,'identCodeCheck')"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="发证机关" field="issueAuthority" span="8">
        <template v-slot="scope">
          <vxe-input
              :class="issueAuthorityCheck ? 'rowInput check' : 'rowInput'"
              v-model="formData.issueAuthority"
              :readonly="readOnly"
              :placeholder="readOnly ? '' : '请输入发证机关'"
              :clearable="!readOnly"
              @blur="clearV"
              @input="updateScope(scope,'issueAuthorityCheck')"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="核定载质量(吨)" field="deadweight" span="8">
        <template v-slot="scope">
          <vxe-input
              :class="deadweightCheck ? 'rowInput check' : 'rowInput'"
              v-model="formData.deadweight"
              :readonly="readOnly"
              :placeholder="readOnly ? '' : '为空输入准牵引总质量'"
              :clearable="!readOnly"
              type="number"
              @input="updateScope(scope,'deadweightCheck')"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="车辆总质量(吨)" field="totalWeight" span="8">
        <template v-slot="scope">
          <vxe-input
              :class="totalWeightCheck ? 'rowInput check' : 'rowInput'"
              v-model="formData.totalWeight"
              :readonly="readOnly"
              :placeholder="readOnly ? '' : '请输入车辆总质量'"
              :clearable="!readOnly"
              type="number"
              @input="updateScope(scope,'totalWeightCheck')"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="整备质量(吨)" field="curbWeight" span="8">
        <template v-slot="scope">
          <vxe-input
              :class="curbWeightCheck ? 'rowInput check' : 'rowInput'"
              v-model="formData.curbWeight"
              :readonly="readOnly"
              :placeholder="readOnly ? '' : '请输入整备质量'"
              :clearable="!readOnly"
              type="number"
              @input="updateScope(scope,'curbWeightCheck')"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="注册日期" field="regTime" span="8">
        <template v-slot="scope">
          <vxe-input
              :class="regTimeCheck ? 'rowInput check' : 'rowInput'"
              v-model="formData.regTime"
              :disabled="readOnly"
              type="date"
              :placeholder="readOnly ? '' : '请选择日期'"
              :clearable="!readOnly"
              @input="updateScope(scope,'regTimeCheck')"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="发证日期" field="issueTime" span="8">
        <template v-slot="scope">
          <vxe-input
              :class="issueTimeCheck ? 'rowInput check' : 'rowInput'"
              v-model="formData.issueTime"
              :disabled="readOnly"
              type="date"
              :placeholder="readOnly ? '' : '请选择日期'"
              :clearable="!readOnly"
              @input="updateScope(scope,'issueTimeCheck')"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="检验有效期至" field="checkPassTime" span="8">
        <template v-slot>
          <vxe-input
              v-model="formData.checkPassTime"
              :disabled="readOnly"
              type="date"
              :placeholder="readOnly ? '' : '请选择日期'"
              :clearable="!readOnly"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="车辆所有人" field="owner" span="8">
        <template v-slot="scope">
          <vxe-input
              :class="ownerCheck ? 'rowInput check' : 'rowInput'"
              v-model="formData.owner"
              :readonly="readOnly"
              :placeholder="readOnly ? '' : '请输入车辆所有人'"
              :clearable="!readOnly"
              @input="updateScope(scope,'ownerCheck')"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="使用性质" field="useNature" span="8">
        <template v-slot="scope">
          <vxe-input
              :class="useNatureCheck ? 'rowInput check' : 'rowInput'"
              v-model="formData.useNature"
              :readonly="readOnly"
              :placeholder="readOnly ? '' : '请输入使用性质'"
              :clearable="!readOnly"
              @input="updateScope(scope,'useNatureCheck')"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item span="24">
        <template>
          <div class="block-car">
            <div class="block-tip"></div>
            <span class="block-title">道路运输证（营运证）信息</span>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="车辆道路运输证号" field="transportCardNum" span="8">
        <template v-slot="scope">
          <vxe-input
              class="rowInput"
              v-model="formData.transportCardNum"
              :readonly="readOnly"
              maxlength="25"
              :placeholder="readOnly ? '' : '请输入车辆道路运输证号'"
              :clearable="!readOnly"
              @blur="clearV"
              @input="$refs.xForm.updateStatus(scope)"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="经营许可证号" field="businessNum" span="8">
        <template v-slot="scope">
          <vxe-input
              class="rowInput"
              type="number"
              v-model="formData.businessNum"
              :readonly="readOnly"
              maxlength="30"
              :placeholder="readOnly ? '' : '请输入12或13位经营许可证号'"
              :clearable="!readOnly"
              @blur="clearV"
              @input="$refs.xForm.updateStatus(scope)"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="有效期至" field="transportPassTime" span="8">
        <template v-slot>
          <vxe-input
              v-model="formData.transportPassTime"
              :disabled="readOnly"
              type="date"
              :placeholder="readOnly ? '' : '请选择日期'"
              :clearable="!readOnly"
          ></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item
          title="道路运输证(正面)"
          field="transportCardFrontImage"
          span="8"
          style="height: 100px"
      >
        <template>
          <div style="display: flex">
            <div
                v-if="!readOnly"
                style="display: flex; flex-direction: column; align-items: center"
            >
              <img style="margin-right: 5px" src="@/assets/images/common/dlyszzm.png"/>
              <span style="font-size: 8px; color: #539fff">示例图</span>
            </div>
            <upload-img
                :row="formData"
                :readOnly="readOnly"
                :fileKey="'transportCardFrontImage'"
                :initFile="formData.transportCardFrontImage"
                :width="80"
                :height="80"
            ></upload-img>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item
          title="道路运输证(副页)"
          field="transportCardSubpageImage"
          span="8"
          style="height: 100px"
      >
        <template>
          <div style="display: flex">
            <div
                v-if="!readOnly"
                style="display: flex; flex-direction: column; align-items: center"
            >
              <img style="margin-right: 5px" src="@/assets/images/common/dlyszzm.png"/>
              <span style="font-size: 8px; color: #539fff">示例图</span>
            </div>
            <upload-img
                :row="formData"
                :readOnly="readOnly"
                :fileKey="'transportCardSubpageImage'"
                :initFile="formData.transportCardSubpageImage"
                :width="80"
                :height="80"
            ></upload-img>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item v-if="!readOnly" span="24">
        <template>
          <span style="margin-left: 36px; font-size: 14px; font-weight: 400; color: #f94b4b"
          >提示：总质量 4.5 吨及以下车辆，道路运输证号及经营许可证号可填“车籍地 6
            位行政区域代码+000000”</span
          >
        </template>
      </vxe-form-item>
      <vxe-form-item align="right" span="24" v-if="isUpdate">
        <template v-slot>
          <vxe-button type="reset" @click="reset">取消</vxe-button>
          <vxe-button
              v-if="readOnly && formData.authStatus !== 3"
              type="button"
              @click="showUpdate"
              status="primary"
          >
            编辑
          </vxe-button>
          <vxe-button v-if="!readOnly" type="submit" status="primary" @click="commit"
          >保存
          </vxe-button
          >
        </template>
      </vxe-form-item>
    </vxe-form>
    <div class="no-permission" v-else>
      <div class="no-permission-bg"></div>
      <div class="no-permission-txt">您无查看权限</div>
    </div>
  </div>
</template>

<script>
import $C from "@/consts/index";
import $api from "@/apiProvider";
import {showLoading, hideLoading} from "@/utils/util";
import UploadImg from "@/components/common/UploadImg";

export default {
  components: {UploadImg},
  data() {
    const number = ({itemValue}) => {
      if (itemValue && itemValue !== "") {
        let reg = /^\d+(?=\.{0,1}\d+$|$)/;
        if (!reg.test(itemValue)) {
          return Promise.reject(new Error("请输入正确的数字"));
        }
      }
    };
    return {
      formData: {
        id: "",
        carNum: null,
        carTypeText: [],
        owner: null,
        deadweight: null,
        carNumColor: null,
        carHeight: null,
        carLength: null,
        carWidth: null,
        totalWeight: null,
        transportCardNum: null,
        archivesNum: null,
        drivingCardFrontImage: null,
        drivingCardSubpageImage: null,
        transportCardFrontImage: null,
        transportCardSubpageImage: null,
        energyType: null,
        identCode: null,
        issueAuthority: null,
        curbWeight: null,
        regTime: null,
        issueTime: null,
        checkPassTime: null,
        useNature: null,
        businessNum: null,
        transportPassTime: null,
      },
      isUpdate: true,
      car_Num_Color: [],
      energy_Type: [],
      formRules: {
        carNum: [{required: true, message: "请输入车牌号"}],
        // transportCardNum: [
        //   {max: 12, min: 12, message: "请输入正确的车辆道路运输证号"}
        // ],
        archivesNum: [{max: 12, min: 12, message: "请输入正确的车辆行驶证档案编号"}],
        identCode: [{max: 17, min: 17, message: "请输入正确的车辆识别代码"}],
        businessNum: [{max: 13, min: 12, message: "请输入正确的经营许可证号"}],
        carHeight: [{validator: number}],
        carLength: [{validator: number}],
        carWidth: [{validator: number}],
        totalWeight: [{validator: number}],
        deadweight: [{validator: number}],
        curbWeight: [{validator: number}],
      },
      carTypeList: [],
      dict: [],
      readOnly: false,
      isShowDetail: true,
      archivesNumCheck: false,
      identCodeCheck: false,
      issueAuthorityCheck: false,
      deadweightCheck: false,
      totalWeightCheck: false,
      curbWeightCheck: false,
      regTimeCheck: false,
      issueTimeCheck: false,
      ownerCheck: false,
      useNatureCheck: false,
      carNumCheck: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    updateScope(scope, key) {
      this[key] = false;
      this.$refs.xForm.updateStatus(scope);
    },
    getOcrVehicle(data) {
      if (data.haopaihaoma && data.haopaihaoma !== '') {
        if (this.formData.carNum && this.formData.carNum !== '' && this.formData.carNum !== data.haopaihaoma) {
          this.carNumCheck = true;
        }
        this.$set(this.formData, 'carNum', data.haopaihaoma);
      }
      if (data.danganbianhao && data.danganbianhao !== '') {
        if (this.formData.archivesNum && this.formData.archivesNum !== '' && this.formData.archivesNum !== data.danganbianhao) {
          this.archivesNumCheck = true;
        }
        this.$set(this.formData, 'archivesNum', data.danganbianhao);
      }
      if (data.cheliangshibiedaihao && data.cheliangshibiedaihao !== '') {
        if (this.formData.identCode && this.formData.identCode !== '' && this.formData.identCode !== data.cheliangshibiedaihao) {
          this.identCodeCheck = true;
        }
        this.$set(this.formData, 'identCode', data.cheliangshibiedaihao);
      }
      if (data.fazhengdanwei && data.fazhengdanwei !== '') {
        if (this.formData.issueAuthority && this.formData.issueAuthority !== '' && this.formData.issueAuthority !== data.fazhengdanwei) {
          this.issueAuthorityCheck = true;
        }
        this.$set(this.formData, 'issueAuthority', data.fazhengdanwei);
      }
      if (data.hedingzaizhiliang && data.hedingzaizhiliang !== '') {
        if (this.formData.deadweight && this.formData.deadweight !== '' && this.formData.deadweight !== (parseInt(data.hedingzaizhiliang) / 1000).toFixed(2)) {
          this.deadweightCheck = true;
        }
        this.$set(this.formData, 'deadweight', (parseInt(data.hedingzaizhiliang) / 1000).toFixed(2));
      }
      if (data.zongzhiliang && data.zongzhiliang !== '') {
        if (this.formData.totalWeight && this.formData.totalWeight !== '' && this.formData.totalWeight !== (parseInt(data.zongzhiliang) / 1000).toFixed(2)) {
          this.totalWeightCheck = true;
        }
        this.$set(this.formData, 'totalWeight', (parseInt(data.zongzhiliang) / 1000).toFixed(2));
      }
      if (data.zhengbeizhiliang && data.zhengbeizhiliang !== '') {
        if (this.formData.curbWeight && this.formData.curbWeight !== '' && this.formData.curbWeight !== (parseInt(data.zhengbeizhiliang) / 1000).toFixed(2)) {
          this.curbWeightCheck = true;
        }
        this.$set(this.formData, 'curbWeight', (parseInt(data.zhengbeizhiliang) / 1000).toFixed(2));
      }
      if (data.zhuceriqi && data.zhuceriqi !== '') {
        let date = this.insertStr(data.zhuceriqi, 4, '-');
        date = this.insertStr(date, 7, '-');
        if (this.formData.regTime && this.formData.regTime !== '' && this.formData.regTime !== date) {
          this.regTimeCheck = true;
        }
        this.$set(this.formData, 'regTime', date);
      }
      if (data.fazhengriqi && data.fazhengriqi !== '') {
        let date = this.insertStr(data.fazhengriqi, 4, '-');
        date = this.insertStr(date, 7, '-');
        if (this.formData.issueTime && this.formData.issueTime !== '' && this.formData.issueTime !== date) {
          this.issueTimeCheck = true;
        }
        this.$set(this.formData, 'issueTime', date);
      }
      if (data.suoyouren && data.suoyouren !== '') {
        if (this.formData.owner && this.formData.owner !== '' && this.formData.owner !== data.suoyouren) {
          this.ownerCheck = true;
        }
        this.$set(this.formData, 'owner', data.suoyouren);
      }
      if (data.shiyongxingzhi && data.shiyongxingzhi !== '') {
        if (this.formData.useNature && this.formData.useNature !== '' && this.formData.useNature !== data.shiyongxingzhi) {
          this.useNatureCheck = true;
        }
        this.$set(this.formData, 'useNature', data.shiyongxingzhi);
      }
      if (data.waikuochicun && data.waikuochicun !== '') {
        let carSize = data.waikuochicun.split('mm')[0];
        let carSize1 = carSize.split('X')
        this.$set(this.formData, 'carLength', carSize1[0]);
        this.$set(this.formData, 'carWidth', carSize1[1]);
        this.$set(this.formData, 'carHeight', carSize1[2]);
      }
      if (data.cheliangleixing && data.cheliangleixing !== '') {
        let arr = [];
        this.carTypeList.map(i => {
          i.children.map(j => {
            if (j.label === data.cheliangleixing) {
              arr = [i.value, j.value]
            }
          })
        })
        this.$set(this.formData, 'carTypeText', arr);
      }

      if (data.ranyouleixing && data.ranyouleixing !== '') {
        this.energy_Type.map(i => {
          if (i.label === data.ranyouleixing) {
            this.$set(this.formData, 'energyType', i.value);
          }
        })
      }
    },
    insertStr(source, start, newStr) {
      return source.slice(0, start) + newStr + source.slice(start)
    },
    init() {
      this.searchTreeByCodeP(40200);
      this.getCarColor(40300, "car_Num_Color");
      this.getCarColor(40400, "energy_Type");
    },
    clearV() {
      if (this.$refs.xForm) {
        this.$refs.xForm.clearValidate();
      }
    },
    async validEvent() {
      let errMap = await this.$refs.xForm.validate().catch((errMap) => errMap);
      return errMap ? false : true;
    },
    setReadOnly() {
      this.readOnly = true;
      let dom = Array.from(document.getElementsByClassName("rowInput"));
      dom.map((i) => {
        i.childNodes[0].style.border = "none";
      });
    },
    setNoUpdate() {
      this.isUpdate = false;
    },
    showUpdate() {
      this.readOnly = false;
      let dom = Array.from(document.getElementsByClassName("rowInput"));
      dom.map((i) => {
        i.childNodes[0].style.border = "";
      });
    },
    async getCarColor(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code,
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map((i) => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          });
        });
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    async searchTreeByCodeP(code) {
      let res = await $api.dict.get("searchTreeByCodeP", {
        parentcode: code,
      });
      if (res.status === 1) {
        let data = res.data;
        this.carTypeList = [];
        data.map((i) => {
          let obj = {
            label: i.dictText,
            value: i.dictCode,
            children: [],
          };
          i.children.map((j) => {
            obj.children.push({
              label: j.dictText,
              value: j.dictCode,
            });
          });
          if (obj.children.length === 0) {
            obj.disabled = true;
          }
          this.carTypeList.push(obj);
        });
      } else {
        this.$XModal.message(res.message);
      }
    },
    async commit() {
      let sts = await this.validEvent();
      if (!sts) {
        return;
      }
      if (this.formData.checkPassTime) {
        this.formData.checkPassTime = this.$utils.timestamp(this.formData.checkPassTime);
      }
      if (this.formData.issueTime) {
        this.formData.issueTime = this.$utils.timestamp(this.formData.issueTime);
      }
      if (this.formData.regTime) {
        this.formData.regTime = this.$utils.timestamp(this.formData.regTime);
      }
      if (this.formData.transportPassTime) {
        this.formData.transportPassTime = this.$utils.timestamp(this.formData.transportPassTime);
      }

      if (this.formData.id === "") {
        this.save();
      } else {
        this.update();
      }
    },
    reset() {
      this.formData = {
        id: "",
        carNum: null,
        carTypeText: [],
        owner: null,
        deadweight: null,
        carNumColor: null,
        carHeight: null,
        carLength: null,
        carWidth: null,
        totalWeight: null,
        transportCardNum: null,
        archivesNum: null,
        drivingCardFrontImage: null,
        drivingCardSubpageImage: null,
        transportCardFrontImage: null,
        transportCardSubpageImage: null,
        energyType: null,
        identCode: null,
        issueAuthority: null,
        curbWeight: null,
        regTime: null,
        issueTime: null,
        checkPassTime: null,
        useNature: null,
        businessNum: null,
        transportPassTime: null,
      };
      this.clearV();
      this.$emit("close");
    },
    async save() {
      showLoading();
      let obj = Object.assign({}, this.formData);
      obj.carNum = obj.carNum.trim();
      obj.carTypeText = obj.carTypeText.toString();
      let res = await $api.carShip.request("createCar", [obj]);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("提交成功");
        this.reset();
        this.$emit("afterSave", "afterSave");
      } else {
        this.$XModal.alert({
          message: res.data[0].failMsg ? res.data[0].failMsg : "接口异常",
          status: "error",
        });
      }
    },
    async update() {
      showLoading();
      let obj = Object.assign({}, this.formData);
      obj.carNum = obj.carNum.trim();
      obj.carTypeText = obj.carTypeText.toString();
      let res = await $api.carShip.request("updateCar", obj);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("修改成功");
        this.reset();
        this.$emit("afterSave", "afterSave");
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async queryCarDetail(carShipId) {
      let res = await $api.carShip.request("queryCarDetail", {
        id: carShipId,
      });
      if (res.status === 1) {
        this.isShowDetail = true;
        this.formData = Object.assign({}, res.data);
        if (this.formData.regTime) {
          this.formData.regTime = this.$utils.toDateString(this.formData.regTime, "yyyy-MM-dd");
        }
        if (this.formData.issueTime) {
          this.formData.issueTime = this.$utils.toDateString(this.formData.issueTime, "yyyy-MM-dd");
        }
        if (this.formData.checkPassTime) {
          this.formData.checkPassTime = this.$utils.toDateString(
              this.formData.checkPassTime,
              "yyyy-MM-dd"
          );
        }
        if (this.formData.transportPassTime) {
          this.formData.transportPassTime = this.$utils.toDateString(
              this.formData.transportPassTime,
              "yyyy-MM-dd"
          );
        }
        if (this.formData.carTypeText) {
          let carTypeList = this.formData.carTypeText.split(",");
          this.formData.carTypeText = [parseInt(carTypeList[0]), parseInt(carTypeList[1])];
        } else {
          this.formData.carTypeText = [];
        }
      } else if (res.status === 10009) {
        this.isShowDetail = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    setUpdate(row) {
      // let updateDate = Object.assign({}, row);
      this.isUpdate = true;
      this.queryCarDetail(row.id);
      // this.formData = updateDate;
      // if (this.formData.regTime) {
      //   this.formData.regTime = this.$utils.toDateString(this.formData.regTime, "yyyy-MM-dd");
      // }
      // if (this.formData.issueTime) {
      //   this.formData.issueTime = this.$utils.toDateString(this.formData.issueTime, "yyyy-MM-dd");
      // }
      // if (this.formData.checkPassTime) {
      //   this.formData.checkPassTime = this.$utils.toDateString(
      //       this.formData.checkPassTime,
      //       "yyyy-MM-dd"
      //   );
      // }
      // if (this.formData.transportPassTime) {
      //   this.formData.transportPassTime = this.$utils.toDateString(
      //       this.formData.transportPassTime,
      //       "yyyy-MM-dd"
      //   );
      // }
      // if (this.formData.carTypeText) {
      //   this.formData.carTypeText = [
      //     parseInt(this.formData.carTypeText[0]),
      //     parseInt(this.formData.carTypeText[1]),
      //   ];
      // } else {
      //   this.formData.carTypeText = [];
      // }
      // this.formData.id = row.id;
      // this.formData.carNum = row.carNum;
      // this.formData.deadweight = row.deadweight;
      // this.formData.carNumColor = row.carNumColor;
      // this.formData.carHeight = row.carHeight;
      // this.formData.archivesNum = row.archivesNum;
      // this.formData.carLength = row.carLength;
      // this.formData.carWidth = row.carWidth;
      // this.formData.owner = row.owner;
      // this.formData.drivingCardFrontImage = row.drivingCardFrontImage;
      // this.formData.drivingCardSubpageImage = row.drivingCardSubpageImage;
      // this.formData.transportCardFrontImage = row.transportCardFrontImage;
      // this.formData.transportCardSubpageImage = row.transportCardSubpageImage;
      // this.formData.transportCardNum = row.transportCardNum;
      // this.formData.archivesNum = row.archivesNum;
      // this.formData.totalWeight = row.totalWeight;
    },
  },
};
</script>

<style scoped>
.block-car {
  display: flex;
  align-items: center;
}

.block-tip {
  width: 4px;
  height: 16px;
  background: #539fff;
}

.block-title {
  margin-left: 4px;
  height: 21px;
  font-size: 16px;
  font-weight: bold;
  line-height: 21px;
  color: #539fff;
}

.check >>> .vxe-input--inner {
  border: 1px solid red;
}
</style>
